"use client";

import { useQuery } from "@tanstack/react-query";

async function fetchLiveTickers(): Promise<Set<string>> {
  const res = await fetch("/api/markets/kalshi/live-tickers");
  if (!res.ok) return new Set();
  const data = (await res.json()) as { tickers?: string[] };
  return new Set(
    (data.tickers || [])
      .filter((t): t is string => typeof t === "string")
      .map((t) => t.toUpperCase())
  );
}

/**
 * Returns a Set of Kalshi event tickers currently in progress.
 * Refreshed every 30s. Use `liveSet.has(ticker.toUpperCase())` per card —
 * no per-card requests.
 */
export function useKalshiLiveTickers(enabled = true) {
  return useQuery<Set<string>>({
    queryKey: ["kalshi", "live-tickers"],
    queryFn: fetchLiveTickers,
    enabled,
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
    staleTime: 20_000,
    gcTime: 5 * 60 * 1000,
  });
}
